// LegalNotice.jsx

import { useTranslation, Trans } from 'react-i18next';
import PageTracker from '../../components/tracking/PageTracker';
import ScrollTracker from '../../components/tracking/ScrollTracker';

function LegalNotice() {
  const { t } = useTranslation();  

  return (
    <div className="legal-page">
      <PageTracker pageName="LegalNotice" />
      <section className="legal-content">
        <Trans 
        i18nKey="legal_notice_whole_text" 
        components={{
          h1: <h1>{t('Title')}</h1>,
          h2: <h2>{t('Subtitle')}</h2>,
          h3: <h3>{t('Section')}</h3>,
          h4: <h4>{t('Subsection')}</h4>,
          p: <p />,
          ul: <ul style={{ paddingLeft: '20px', listStyleType: 'disc' }} />,
          li: <li style={{ marginBottom: '5px' }} />,
          strong: <strong />,
        }}>
        </Trans>
      </section>
      <ScrollTracker pageName="LegalNotice" />
    </div>
  );
}

export default LegalNotice;